import Vue from "vue";

export default {
	state: {
		users: [],
		notExternalUsers: [],
		userActorFamilies: [],
		userActorCompanies: [],
		userToEdit: {},
		userPagination: {}
	},
	mutations: {
		setUsersOnState(state, users) {
			state.users = users;
		},
		setNotExternalUsersOnState(state, notExternalUsers) {
			state.notExternalUsers = notExternalUsers;
			state.notExternalUsers.unshift({
				idUser: 0,
				login: "",
				name: "-",
				isActive: true
			});
		},
		setUserActorFamiliesOnState(state, userActorFamilies) {
			state.userActorFamilies = userActorFamilies;
		},
		setUserActorCompaniesOnState(state, userActorCompanies) {
			state.userActorCompanies = userActorCompanies;
		},
		setUserToEditOnState(state, userToEdit) {
			Vue.set(state.userToEdit, "actors", userToEdit.actors);
			state.userToEdit = userToEdit;
		},
		setUsersPaginationOnState(state, userPagination) {
			state.userPagination = userPagination;
		},
		cleanUserToEdit(state) {
			state.userToEdit = [];
		}
	},

	actions: {
		getUsers({ commit }) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("user")
					.then((response) => {
						this.state.loading = false;
						commit("setUsersOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getUsersWithPagination({ commit }, filterData) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.get("user/pagination", filterData).then((response) => {
					this.state.loading = false;
					if (response.error) {
						Vue.prototype.$functions.displayError(this._vm, response.error);
						return;
					}
					commit("setUsersOnState", response.data.data.list);
					commit("setUsersPaginationOnState", response.data.data.pagination);
					resolve(response.data.data.pagination);
				});
			});
		},
		getNotExternalUsers({ commit }) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("/notExternal")
					.then((response) => {
						this.state.loading = false;
						commit("setNotExternalUsersOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		userIsRegistered(_, login) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("login/" + login)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch(() => {
						reject();
					});
			});
		},
		getUserById({ commit }, userId) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("user/" + userId)
					.then((response) => {
						commit("setUserToEditOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						reject();
					});
			});
		},
		getUserByRandomKey({ commit }, randomKey) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("/randomKey/" + randomKey)
					.then((response) => {
						commit("setUserToEditOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						reject();
					});
			});
		},
		getUserByEmail(_, email) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("/email/" + email)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch(() => {
						reject();
					});
			});
		},
		getActorsByUser(_, userId) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("user/" + userId)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getUserPermissionsById({ commit }, userId) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("user/permissions/" + userId)
					.then((response) => {
						this.state.loading = false;
						commit("setUserPermissionsOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		updateUser({ state, commit }, user) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				mapUser(user, true).then((mappedUser) => {
					Vue.prototype.$http
						.put("user", mappedUser)
						.then((response) => {
							const actualUser = JSON.parse(JSON.stringify(state.actualUser));
							commit("setUserToEditOnState", actualUser);
							if (user.id === mappedUser.user.idUser) {
								actualUser.haveLogPermission = mappedUser.permissionList.includes(1320);
								actualUser.actorList = mappedUser.actorList.map((actor) => actor.id);
								commit("setActualUserOnState", actualUser);
							}
							this.state.loading = false;
							resolve(response.data.data);
						})
						.catch((error) => {
							this.state.loading = false;
							reject(error.message);
						});
				});
			});
		},
		updateUserSupplier(_, data) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("User/updateSupplier", data)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		createUser(_, user) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				mapUser(user, false).then((mappedUser) => {
					Vue.prototype.$http
						.post("user", mappedUser)
						.then((response) => {
							this.state.loading = false;
							resolve(response.data.data);
						})
						.catch((error) => {
							this.state.loading = false;
							reject(error.response.data.error.message);
						});
				});
			});
		},
		deleteUserById(_, user) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.delete("user/" + user.idUser, user)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		checkUserEmailExistance(_, data) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("user/checkEmail", data)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getUserActorFamilies({ commit }, dataObject) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("user/userActorFamily", dataObject)
					.then((response) => {
						this.state.loading = false;
						commit("setUserActorFamiliesOnState", response.data.data.userActorFamilies);
						commit("setUserActorCompaniesOnState", response.data.data.userActorCompanies);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getAllUserActorFamilies(_, payload = {}) {
			const { idUser, isIframeContext = false } = payload;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("user/allUserActorFamily/" + idUser, {}, { isIframeContext })
					.then((response) => {
						resolve(response.data.data);
					})
					.catch(() => {
						reject();
					});
			});
		},
		deleteUserActorFamily(_, dataObject) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("user/ActorFamilyDelete", dataObject)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getUserInfo({ state, commit }, { isIframeContext = false } = {}) {
			if (state.isUserLoaded) return Promise.resolve(state.actualUser);

			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("user/info", {}, { isIframeContext })
					.then((response) => {
						commit("setActualUserOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						reject();
					});
			});
		}
	},

	getters: {
		users({ users }) {
			return users;
		},
		userPagination({ userPagination }) {
			return userPagination;
		},
		notExternalUsers({ notExternalUsers }) {
			return notExternalUsers;
		},
		userToEdit({ userToEdit }) {
			return userToEdit;
		},
		userActorFamilies({ userActorFamilies }) {
			return userActorFamilies;
		},
		userActorCompanies({ userActorCompanies }) {
			return userActorCompanies;
		}
	}
};

function mapUser(user, isUpdate) {
	return new Promise((resolve) => {
		const formattedUserActorFamilyList = (() => {
			let families = user.userActorFamilies || [];
			let noneSelected = !families.some(({ idFamily }) => idFamily != 0);

			return {
				userActorFamilyList: families.filter((item) => item.idFamily !== 0),
				noneSelected: noneSelected
			};
		})();

		const formattedUserActorCompanyList = (() => {
			let companies = user.userActorCompanies || [];
			let noneSelected = !companies.some(({ idCompany }) => idCompany != 0);

			return {
				userActorCompanyList: companies.filter((item) => item.idCompany !== 0),
				noneSelected: noneSelected
			};
		})();

		let mappedUser = {
			user: {
				name: user.name,
				isAdmin: user.isAdmin
			},
			permissionList: user.permissions ?? [],
			actorList: user.actors ? user.actors : [],
			clientList: user.clients ? user.clients : [],
			updateAllUserInfo: user.updateAllUserInfo ?? true,
			userActorFamilyList: isUpdate ? formattedUserActorFamilyList : formattedUserActorFamilyList.userActorFamilyList,
			userActorCompanyList: isUpdate
				? formattedUserActorCompanyList
				: formattedUserActorCompanyList.userActorCompanyList
		};

		if (user.login) {
			mappedUser.user.password = user.password;
			mappedUser.user.login = user.login;
			mappedUser.user.idUser = user.id;
			mappedUser.user.email = user.email;
			mappedUser.user.isActive = user.isActive;
			mappedUser.user.isAdmin = user.isAdmin;
		}
		resolve(mappedUser);
	});
}
